import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import { formatErrorMessage } from '../utils/errorHandler';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUserInfo();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await api.get('/auth/me');
      setUser(response.data);
    } catch (error) {
      console.error('ユーザー情報取得エラー:', error);
      localStorage.removeItem('token');
      delete api.defaults.headers.common['Authorization'];
    } finally {
      setLoading(false);
    }
  };

  const applyToken = async (token) => {
    localStorage.setItem('token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const response = await api.get('/auth/me');
    setUser(response.data);
  };

  const login = async (email, password) => {
    try {
      console.log('ログイン試行:', { email }); // デバッグログ
      const response = await api.post('/auth/login', { email, password });
      console.log('ログインレスポンス:', response.data); // デバッグログ
      const { token, user } = response.data;

      localStorage.setItem('token', token);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(user);
      console.log('ユーザー設定完了:', user); // デバッグログ

      return { success: true };
    } catch (error) {
      console.error('ログインエラー:', error); // デバッグログ
      const message = formatErrorMessage(error);
      return { success: false, error: message };
    }
  };

  const loginWithToken = async (token) => {
    try {
      await applyToken(token);
      return { success: true };
    } catch (error) {
      console.error('トークンログインエラー:', error);
      localStorage.removeItem('token');
      delete api.defaults.headers.common['Authorization'];
      const message = formatErrorMessage(error);
      return { success: false, error: message };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
  };

  const value = {
    user,
    login,
    loginWithToken,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}